// extracted by mini-css-extract-plugin
module.exports = {"dualFields":"TenantPassportDataModal_dualFields__2yt_w","formItem":"TenantPassportDataModal_formItem__2pZsz"};